import { render, staticRenderFns } from "./TableCellDuration.vue?vue&type=template&id=865205d4"
import script from "./TableCellDuration.vue?vue&type=script&lang=js"
export * from "./TableCellDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports